import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef  } from '@angular/core';
import { RestService } from '../rest.service';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { Router } from '@angular/router';
import { ModalsComponent } from '../modals/modals.component';
import { MatDialog } from '@angular/material/dialog';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DynamicFontSizePipe } from 'app/shared/dynamic-font-size.pipe';


@Component({
  selector: 'usb-suggestion',
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.scss'],
  providers: [DynamicFontSizePipe]
})
export class SuggestionComponent implements OnInit {
  public fontSizeAdjustments = { 5: -1, 6: -1, 8: -2, 10: -3, 12: -5, 14: -6 };

  @Input() getClientsSettingAppBooking: any;
  @Input() actualItinerary: any;
  @Input() currencies: any;
  @Input() currencyAgency: any;
  @Input() paymentAgencyActive: any;
  @Output() suggestionsCategories: EventEmitter<any> = new EventEmitter<any>();
  @Output() reloadEmmit: EventEmitter<any> = new EventEmitter<any>();
  suggestions: any;
  sugestionEssencial: any[] = [];
  sugestionImportant: any;
  noData = false;
  modalRef: BsModalRef;
  modalTours: any;
  payload: any;

  constructor(public dialog: MatDialog,private _restService: RestService, private userService: UserService, private router: Router, private dynamicFontSizePipe: DynamicFontSizePipe) { }


  ngOnInit(): void {
    this.getSuggestionsBig();
  }

          /**
           * Obtiene las sugerencias asociadas al itinerario actual
           *
           * Este método llama al endpoint `suggestionsByID/{id}` para recuperar sugerencias
           * y las asigna a la variable `this.suggestions`.
           *
           * @url {string} - Endpoint construido con el ID del itinerario actual.
           * @suggestions {any[]} - Arreglo con las sugerencias obtenidas del backend.
           * @response {any} - Objeto de respuesta que contiene las sugerencias.
           * @error {HttpErrorResponse} - Objeto que representa un error de respuesta HTTP.
           */
          getSuggestionsBig() {

            const payload = JSON.parse(localStorage.getItem('payload'));
            const form = JSON.parse(localStorage.getItem('form'));
            const payloadSuggestion = {};

            payloadSuggestion['providerId'] = null;
            payloadSuggestion['categoriesId'] = [9];
            payloadSuggestion['origin'] = '';
            payloadSuggestion['city'] = 'Miami';
            payloadSuggestion['priceFrom'] = 0;
            payloadSuggestion['priceTo'] = 20000;
            payloadSuggestion['market'] = 2;

            if(payload && payload.length > 0) {
              payloadSuggestion['others'] = {
                maxRequestTimeOnSeconds : 120,
                    minNumResults : 4,
                    maxNumResultsPerAdapter :'',
                    tours : {
                        adults : 1,
                        children : []
                    }
              };

              this.payloadSuggestionValuesCategories(payloadSuggestion, payload, form);

            } else {
              const itinerary = this.actualItinerary;
              if(itinerary) {
                if(this.actualItinerary.destination && this.actualItinerary.destination.length === 0) {
                  this.noData = true;
                  return;
                }
                const destination = this.actualItinerary.destination[0].destination_info;
                const iata_code = this.actualItinerary.destination[0].iata_code;
                const city_name = this.actualItinerary.destination[0].cityName;

                 payloadSuggestion['others'] = {
                  maxRequestTimeOnSeconds : 120,
                      minNumResults : 4,
                      maxNumResultsPerAdapter :'',
                      tours : {
                          adults : 1,
                          children : []
                      }
                };
                payloadSuggestion['destination'] = iata_code;
                payloadSuggestion['agencyId'] = this.actualItinerary.agency_id;
                payloadSuggestion['nationality'] = 'US';
                payloadSuggestion['arrivalDate'] = destination['arrival'];
                payloadSuggestion['departureDate'] = destination['departure'];
                payloadSuggestion['city'] = city_name;
              }
              }

            const dataSuggestion: any = {
              id: this.actualItinerary?.id,
              userId: this.userService._agentID,
              payload: payloadSuggestion
            };

// Enviar como from: "global" las suggestionsByID al seleccionar, las que vienen de suggestions-by-date -> from: "individual"
if(dataSuggestion) {
  this.payload =  payloadSuggestion;
  const url = 'suggestionsByID';
  this._restService.doPost('app', url,  dataSuggestion).subscribe({
    next: (data: any) => {
      if(data) {
        this.suggestions = data;
        this.suggestionsCategories.emit(this.suggestions);
        this.getSuggestionsTours();
      } else {
        this.noData = true;
      }
    },
    error: (error: HttpErrorResponse) => {
        this.noData = true;
      console.log('error response', error);
    }
  });
}
          }

      payloadSuggestionValuesCategories(payloadSuggestion, payload, form): void {
        switch(payload[0].categoriesId[0]) {
          case 1:
               payloadSuggestion['destination'] = payload[0]?.destination;
              payloadSuggestion['agencyId'] = payload[0]?.agencyId;
              payloadSuggestion['nationality'] = payload[0]?.nationality;
              payloadSuggestion['arrivalDate'] = payload[0].arrivalDate;
              payloadSuggestion['departureDate'] = payload[0].departureDate;
              payloadSuggestion['city'] = this.getCityForm(payload[0].categoriesId[0], form, payload);
              break;
          case 8:
              payloadSuggestion['destination'] = payload[0]?.transfers?.dropoffLocation?.destination;
              payloadSuggestion['agencyId'] = this.userService?._agencyID;
              payloadSuggestion['nationality'] = form?.firstDestination?.country_code;
              payloadSuggestion['arrivalDate'] = payload[0]?.dropoffDate ? payload[0]?.dropoffDate : payload[0]?.pickupDate;
              payloadSuggestion['departureDate'] = payload[0]?.dropoffDate ? payload[0]?.dropoffDate : payload[0]?.pickupDate;
              payloadSuggestion['city'] = this.getCityForm(payload[0].categoriesId[0], form, payload);
        }
      }

          getCityForm(category: number, form: any, payload: any): string {

            switch(category) {
              case 1:
                return form.destination.city_name;
              case 2:
                return form.origin.name;
              case 6:
                return form.destination.city_name;
              case 8:
                return this.getCityNameTranports(form, payload);

              case 10:
                return form.destination;
            }


          }

          getCityNameTranports(form: any, payload: any): string {
            if(payload && payload?.transfers && payload?.transfers.pickupLocation) {
              switch(payload.transfers.dropoffLocation.type) {
                   case 'hotel':
                     return form.hotel_name;
                   case 'airport':
                     return form.name;
                   case 'destination':
                     return form.city_name;
              }

            }

          }

          getSuggestionsTours(): void {
            if(this.suggestions?.TICKETS?.items?.length > 0) {
              let importantAssigned = false;
              this.suggestions.TICKETS.items.forEach((suggestion: any) => {
                // Guard: si el item está mal formado o la moneda no existe en currencies,
                // lo salteamos para no romper la iteración completa con un TypeError.
                const USDbaseSuggestion = this.currencies?.find(c => c.code === suggestion.additionalInfo?.currency)?.rate;
                const adultOption = suggestion.additionalInfo?.tours?.options[0]?.profility?.find(c => c.paxType === 'ADULT');
                const netPrice = adultOption?.netPriceBooking;

                if (!USDbaseSuggestion || !netPrice || !suggestion.additionalInfo?.images?.[0]?.thumbnail) {
                  return;
                }

                const price = netPrice / USDbaseSuggestion;
                const priceTotal = price * this.currencyAgency?.rate;

                // El destacado es el primer item que pasa el guard (no necesariamente
                // el primero del array: ese pudo no tener imagen y haber sido salteado).
                if(!importantAssigned) {
                  importantAssigned = true;
                  this.sugestionImportant = {
                    title: suggestion.title,
                    date:  this.formatDateShort(suggestion.dateIni),
                    image: suggestion?.additionalInfo?.images?.[0]?.thumbnail || null,
                    currency: suggestion.additionalInfo?.currency,
                    price: priceTotal
                  };
                } else {
                  this.sugestionEssencial.push(
                    {
                       title: suggestion.title,
                       description: suggestion.additionalInfo?.tours?.options[0]?.option_name,
                       image: suggestion?.additionalInfo?.images?.[0]?.thumbnail || null,
                       currency: suggestion.additionalInfo?.currency,
                       price: priceTotal
                    }
                  );
                }
              });

              // Si después de iterar todos los items ninguno produjo resultado válido,
              // caemos al estado "sin datos" para que el loader se vaya.
              if (!this.sugestionImportant && this.sugestionEssencial.length === 0) {
                this.noData = true;
              }
            } else {
              this.noData = true;
            }
          }

          formatDateShort(dateStr: string): string {
            const date = new Date(dateStr);
            return date.toLocaleDateString('es-AR', {
              day: '2-digit',
              month: 'short',
              year: 'numeric'
            });
          }

          getImageWidth(): string {
            const currentRoute = this.router.url; // Obtiene la ruta actual
            return currentRoute.includes('/results') ? '299px' : '315px';
          }

            openModal(template?: TemplateRef<any>, tab?: any, type?: string, index?: number) {

              const arrayAux: any[] =  [];

              arrayAux.push({searchId: 1, component: 'suggestion'});
              console.log(this.payload);
              const dialogRef = this.dialog.open(ModalsComponent, {
                width: '100%',
                height: '100%',
                maxWidth: '950px',
                panelClass: 'custom-container-transport',
                data: {
                  modalRoomRef: this.modalRef,
                  product: type === 'imperdible' ? this.suggestions.TICKETS?.items[0] : this.suggestions.TICKETS?.items.find(c => c.title === this.sugestionEssencial[index].title),
                  productQty: this.payload.qtyProduct,
                  payload: this.payload,
                  origin: 'TOURS',
                  arrayResults: arrayAux,
                  tabActive: tab,
                  payloadUpdate: this.payload,
                  paymentAgencyActive: this.paymentAgencyActive,
                  quote: true,
                  action: 'suggestion',
                  from: 'general'
                },
                disableClose: false
              });


              dialogRef.afterClosed().subscribe((result: any) => {
                if(result === 'success') {
                  this.reloadEmmit.emit();
                }
              });
            }

}
